module.exports = __webpack_public_path__ + "img/Chad.85c6d293.svg";